import { Api } from "./base";

const baselineReportServices = {
  getBaselineReports(school_id) {
    return Api.getBaselineData(
      `/school/v1/iro-school-report/?school_id=${school_id}`
    );
  },

  createBaselineReport(data) {
    return Api.postBaselineData(`/school/v1/iro-school-report/`, data);
  },

  updateBaselineReport(payload) {
    return Api.putBaselineData(`/school/v1/iro-school-report/`, payload);
  }
};

export default baselineReportServices;
